<ng-container [ngSwitch]="layout">
    <ng-container *ngSwitchCase="'standard'">
        <div class="flex flex-1 flex-column sm:flex-row justify-content-end mt-2">
            <div class="standard-children-box flex flex-1 flex-wrap align-items-center" [ngClass]="{ 'justify-content-end': config.justifyContent === 'end' }">
                <ng-container *ngTemplateOutlet="contentChildren"></ng-container>
            </div>
            <div class="standard-buttons flex align-items-center justify-content-end">
                <ng-container *ngTemplateOutlet="cancelButtonTmpl"></ng-container>
                <ng-container *ngTemplateOutlet="saveButtonTmpl"></ng-container>
            </div>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'centered'">
        <div class="flex flex-1 flex-wrap align-items-center justify-content-center mt-2">
            <ng-container *ngIf="config.justifyContent === 'start'">
                <ng-container *ngTemplateOutlet="contentChildren"></ng-container>
            </ng-container>

            <ng-container *ngTemplateOutlet="cancelButtonTmpl"></ng-container>
            <ng-container *ngTemplateOutlet="saveButtonTmpl"></ng-container>

            <ng-container *ngIf="config.justifyContent === 'end'">
                <ng-container *ngTemplateOutlet="contentChildren"></ng-container>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngSwitchCase="'spread'">
        <div class="flex flex-1 flex-wrap align-items-center justify-content-between mt-2">
            <ng-container *ngIf="config.justifyContent === 'start'; else spreadXSMEnd">
                <div class="flex flex-1 align-items-center justify-content-start">
                    <ng-container *ngTemplateOutlet="cancelButtonTmpl"></ng-container>
                    <ng-container *ngTemplateOutlet="contentChildren"></ng-container>
                </div>
                <ng-container *ngTemplateOutlet="saveButtonTmpl"></ng-container>
            </ng-container>
            <ng-template #spreadXSMEnd>
                <ng-container *ngTemplateOutlet="cancelButtonTmpl"></ng-container>
                <div class="flex flex-1 flex-wrap align-items-center justify-content-end">
                    <ng-container *ngTemplateOutlet="contentChildren"></ng-container>
                    <ng-container *ngTemplateOutlet="saveButtonTmpl"></ng-container>
                </div>
            </ng-template>
        </div>
    </ng-container>
</ng-container>

<ng-template #contentChildren>
    <ng-content></ng-content>
</ng-template>

<ng-template #cancelButtonTmpl>
    <button
        *ngIf="showCancelButton"
        allowOffline
        pButton
        type="button"
        [label]="cancelLabel"
        class="p-button-tertiary mb-1"
        (click)="cancel()"
        [disabled]="cancelDisabled || disabledOffline">
        <i class="material-icons">clear</i>
    </button>
</ng-template>

<ng-template #saveButtonTmpl>
    <button
        *ngIf="saveEnabled"
        allowOffline
        pButton
        type="submit"
        [label]="saveLabel"
        class="m-button-primary mb-1"
        [ngclass]="{ 'fb-save': layout !== 'centered' || config.justifyContent === 'start' }"
        (click)="save($event)"
        [disabled]="disabled || saving || disabledOffline">
        <p-progressSpinner
            *ngIf="saving"
            [style]="{
                width: '15px',
                height: '15px',
                'vertical-align': 'middle',
                'margin-right': '5px'
            }"></p-progressSpinner>
        <i class="material-icons" *ngIf="!saving">check</i>
    </button>
</ng-template>
